/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorMessage,
  PaymentPollingDto,
} from '../models';
import {
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    PaymentPollingDtoFromJSON,
    PaymentPollingDtoToJSON,
} from '../models';

export interface GetPaymentStatusRequest {
    paymentReference: string;
}

export interface GetPaymentStatusListRequest {
    references: Array<string>;
}

/**
 * 
 */
export class PaymentPollingControllerApi extends runtime.BaseAPI {

    /**
     */
    async getPaymentStatusRaw(requestParameters: GetPaymentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentPollingDto>> {
        if (requestParameters.paymentReference === null || requestParameters.paymentReference === undefined) {
            throw new runtime.RequiredError('paymentReference','Required parameter requestParameters.paymentReference was null or undefined when calling getPaymentStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/payment-polling/{paymentReference}`.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters.paymentReference))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentPollingDtoFromJSON(jsonValue));
    }

    /**
     */
    async getPaymentStatus(requestParameters: GetPaymentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentPollingDto> {
        const response = await this.getPaymentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPaymentStatusListRaw(requestParameters: GetPaymentStatusListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaymentPollingDto>>> {
        if (requestParameters.references === null || requestParameters.references === undefined) {
            throw new runtime.RequiredError('references','Required parameter requestParameters.references was null or undefined when calling getPaymentStatusList.');
        }

        const queryParameters: any = {};

        if (requestParameters.references) {
            queryParameters['references'] = requestParameters.references;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/payment-polling`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentPollingDtoFromJSON));
    }

    /**
     */
    async getPaymentStatusList(requestParameters: GetPaymentStatusListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaymentPollingDto>> {
        const response = await this.getPaymentStatusListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
